<template>
	<div id="chatbox" ref="chatbox">
		<template v-if="selectedUser">
			<div id="chatbox-title" class="text-center" style="padding-top:15px;padding-bottom:15px;border-bottom:1px solid #eee;">
				<span v-if="selectedUser">				
					{{ selectedUser.first_name }} {{ selectedUser.last_name }}
				</span>

				<a href="javascript:void(0);" class="btn btn-danger btn-xs" style="position:absolute;right: 10px;" v-if="selectedUser.type == 'admin'" @click="endSession">End Session</a>
			</div>
			<div id="chatbox-container" @scroll="onMessageScroll" >
				<template v-if="messages.length > 0">
					<div id="messages" >
						<div v-if="loadmore" class="text-center" style="background:#eee;padding-top:10px;padding-bottom:10px">Loading</div>
						<message-item v-if="messages" v-for="(message,index) in messages" :key="'message-' + message.id + message.userid + message.pageid" v-model="messages[index]" :receiver="selectedUser"></message-item>
					</div>
				</template>
				<template v-else>
					<div class="text-center" style="top:30%;position:relative;color:#eee">
						<img src="/static/img/assets/livechat/no_message.png" alt="">
						<p>No message</p>
					</div>
				</template>
			</div>

			<chat-input :app="'facebook'" v-model="selectedUser" @onSendMessage="onSendMessage($event)"></chat-input>
		
		</template>
		<template v-else>
			<div id="chatbox-container">
				<div class="text-center" style="top:30%;position:relative;color:#eee">
					<img src="/static/img/assets/livechat/no_user.png" alt="">
					<p>Select a user</p>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import messageItem from './livechat-message'
import chatInput from './livechat-chatinput'
import api from '@/api'
import moment from 'moment'

export default{
	props: ['value'],
	data: function(){
		return {
			loadmore: false,

			chatboxHeight: 0,
			loading: false,
		    maxTime : 3000,
		    timer: '',
		    isAutoRefresh: true,
		    currentIndex: null,

			selectedUser: this.value,
			offset: 0,
			limit: 100,
			messages: [],

			// oldMessages: [],
			endChatlog: false,

			windowHeight: 0,

			newMessage : null,
		}
	},
	computed: {
	    ...mapGetters({
	        selectedBot: 'selectedBot'
	    })
	},
	components: {
		'message-item' : messageItem,
		'chat-input' : chatInput
	},
	created: function() {
		let vm = this

		this.timer = setInterval(this.getLastedMessages, this.maxTime)
	},
	mounted: function(){
		let vm = this
		vm.windowHeight = window.innerHeight
		vm.matchChatboxHeight();

		this.$nextTick(function() {
			window.addEventListener('resize', function(e) {
				vm.windowHeight = window.innerHeight
				vm.matchChatboxHeight();
			});
		})
	},
	methods: {
		onSendMessage: function(payload) {
			this.messages.push(payload)
			this.snapBottom()
			// console.log(payload)
		},
		getLastedMessages: function(){
			let limit = 15
			if (this.messages.length == 0) {
				limit = 100
			}
			this.getUserMessages(0,limit, true)
		},
		getUserMessages: function(offset,limit,latest){
			let vm = this
			if (vm.selectedBot == null || vm.selectedUser == null || vm.loading) {
				return false;
			}
			vm.loading = true
			let data = {
				pageid : vm.selectedBot.pageid,
				userid: vm.selectedUser.userid,
				offset: offset,
				limit: limit,
				adminid: 'U7afdc9033c8ed7df350b189ff1a2e899'
			}
			if (!latest) {
				vm.loadmore = true
			}

			let auth = null;
			api.getUserMessages(data,function(error, response){
				if (error) {
					console.error(error)
					if (!latest) {
						vm.loadmore = false
					}

					return false;
				}
				if (response.data) {
					if (response.data.length == 0) {
						vm.endChatlog = true 
					}
					if (latest) { 
						if (vm.messages.length == 0) {
							vm.messages = response.data.reverse()
							if (vm.isAutoRefresh) {
								vm.snapBottom()
							}
						} else {
							if (response.data[0].id == vm.currentIndex.id) {
								// console.log('Noting Change')
								vm.loading = false
								return false
							} else {
								let isFoundLatestIndex = false
								let tmpIndex = null
								vm.messages = vm.messages.splice(0, vm.currentIndex.index)
								$.each(response.data,function(index, val){
									if (val.id == vm.currentIndex.id) {
										// console.log('Found')
										tmpIndex = index
										isFoundLatestIndex = true

										return false
									} 
								})

								if (isFoundLatestIndex) {
									for (var i = tmpIndex; i >= 0 ; i--) {
										vm.messages.push(response.data[i])
									}

									if (response.data[0]) {
										vm.newMessage = response.data[0]
									}

									vm.snapBottom()
								}
							}
						}
						
					} else {
						vm.messages = response.data.reverse()
						vm.loadmore = false
						vm.$nextTick(() => {
							let messages = $("#messages")
							if (messages.length > 0) {
								$('#chatbox-container')[0].scrollTop = 250
							}
						})
					}
					if (vm.messages.length > 0) {
						vm.currentIndex = { 
							id : vm.messages[vm.messages.length - 1].id,
							index: vm.messages.length - 1
						}
					}
					vm.loading = false
					
				}
			})
		},
		matchChatboxHeight: function() {
			let vm = this
			this.$nextTick(() => {
				vm.chatboxHeight = vm.windowHeight
				let headerHeight = $('header').outerHeight(true)
				let chatInputHeight = $('#chatinput').outerHeight(true)
				let chatTitle = $('#chatbox-title').outerHeight(true)
				

				if (vm.selectedUser == null) {
					vm.chatboxHeight = vm.chatboxHeight - headerHeight
					$('#chatbox-container').height(vm.chatboxHeight)	
				} else {
					vm.chatboxHeight = vm.chatboxHeight - headerHeight - chatInputHeight - chatTitle
					// console.log(vm.chatboxHeight,headerHeight,chatInputHeight,chatTitle);
					$('#chatbox-container').height(vm.chatboxHeight)	
				}
			})

		},
		enableAutoUpdate: function(){
			this.isAutoRefresh = !this.isAutoRefresh
			if (this.isAutoRefresh) {
				this.timer = setInterval(this.getSummary, this.maxTime)
			} else {
				clearInterval(this.timer)
			}
		},
		onMessageScroll: function(){
			let messages = $("#chatbox-container");
			let scrollPosition = messages.scrollTop()
			let chatboxHeight = messages.outerHeight(true)
			let totalHeight = messages.prop("scrollHeight")
			// console.log(scrollPosition,chatboxHeight,totalHeight)
			if (totalHeight == (scrollPosition + chatboxHeight)) {
				this.isAutoRefresh = true
			} else {
				this.isAutoRefresh = false
			}	

			if (scrollPosition == 0) {
				if (this.loadmore) {
					return false
				}
				this.limit += 100
				this.getUserMessages(this.offset,this.limit,false)
			}
		},
		snapBottom: function(){
			let vm = this
			if (!vm.isAutoRefresh || vm.loadmore) {
				return false
			}
			this.$nextTick(() => {
				let messages = $("#messages")
				if (messages.length > 0) {
					$('#chatbox-container')[0].scrollTop = messages[0].scrollHeight
				}
			})
		},
		resetChatlog: function(){
			this.messages = []
			this.offset = 0
			this.limit = 100
			this.endChatlog = false
			this.loading = false
			this.loadmore = false
			this.isAutoRefresh = true
			this.newMessage = null
		},
		endSession: function(){
			let vm = this
			if (vm.selectedUser == null || vm.selectedBot == null) {
				return false
			}
			let data = {
				pageid : vm.selectedBot.pageid,
				userid: vm.selectedUser.userid,
			}
			vm.$store.dispatch('loading')
			api.endSessionChat(data,function(error, response){
				if (error) {
					console.error(error)
					vm.$store.dispatch('loading')
					return
				}
				vm.$emit('endSession', vm.selectedUser);
				vm.selectedUser = null
				vm.matchChatboxHeight();
				vm.$store.dispatch('loading')
			})
		}
	},
	watch: {
		value : function(newVal, oldVal) {
			this.selectedUser = newVal
			if (newVal == null || oldVal == null || oldVal != newVal) {
				this.resetChatlog()
				this.getLastedMessages()
				this.matchChatboxHeight()
			}
		},
		selectedBot: function(newVal, oldVal){
			if (newVal != oldVal) {
				this.selectedUser = null
				this.resetChatlog()
			}
		}
	},
	beforeDestroy: function() {
		clearInterval(this.timer)
	}

}
</script>


// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chatbox.vue